import api from '@/api'
import { graphql } from '@/axios'
import { fetchLeurisProfileQuery } from '@/graphql'

function runQuery (state, resourceType, query) {
  return graphql(query(
    'person',
    state.fisPersid,
    state.config[resourceType].perPage,
    state.config[resourceType].page,
    state.config[resourceType].sortField,
    state.config[resourceType].sortOrder,
    state.filter[resourceType].filter)
  )
}

export const fetchLeurisProfile = ({commit}, fisPersid) => {
  commit('IS_LOADING', true)
  commit('SET_FISPERSID', fisPersid)
  // leuris profile (maco graphql backend)
  graphql(fetchLeurisProfileQuery({fisPersid}))
  .then((response) => {
    commit('SET_NAME', response.data.data.person.name)
    commit('SET_LEURIS_PROFILE', response.data.data.person.leurisProfile)
    commit('LOADING_DONE')
  })
}

export const fetchResearchSelection = ({commit}, fisPersid) => {
  // research selection (maco phoenix backend)
  api.maco.researchSelection('get', fisPersid).then((data) => {
    commit('SET_RESEARCH_ACTIVITY_AS_FAVOURITE', data)
    commit('LOADING_DONE')
  })
}

export const fetchResearchActivities = ({state, commit}, resourceType) => {
  commit('IS_LOADING', true)

  let fetchData = []
  if (Object.keys(state.data).includes(resourceType)) {
    let resource = state.resourceTypes.filter(resource => resource.type === resourceType)[0]
    fetchData = [
      runQuery(state, resource.type, resource.query)
    ]
  } else {
    state.resourceTypes.forEach(resource => {
      fetchData.push(runQuery(state, resource.type, resource.query))
    })
  }

  return Promise.all(fetchData).then(responses => {
    responses.forEach(response => {
      Object.keys(state.data).forEach(resourceType => {
        if (response) {
          let data = response.data.data['person']
          if (Object.keys(data).includes(resourceType)) {
            commit('SET_DATA', {
              resourceType,
              data: data[resourceType].entries
            })
            commit('SET_TOTAL', {
              resourceType,
              total: data[resourceType].meta.totalEntries
            })
          }
        }
      })

      commit('IS_LOADING', false)
    })
  })
}

export const setResearchActivityAsFavourite = ({ commit }, data) => {
  commit('SET_RESEARCH_ACTIVITY_AS_FAVOURITE', data)
}

export const setConfig = ({state, commit}, { resourceType, property, value }) => {
  commit('SET_CONFIG', { resourceType, property, value })
}

export const setResourceType = ({ state, commit }, type) => {
  commit('SET_RESOURCE_TYPE', type)
}

export const changePage = ({ state, commit }, { resourceType, page }) => {
  commit('CHANGE_PAGE', { resourceType, page })
}

export const setActiveTab = ({state, commit}, activeTab) => {
  commit('SET_ACTIVE_TAB', activeTab)
  commit('SET_RESOURCE_TYPE', state.resourceTypes[activeTab].type)
}

export const setData = ({ state, commit }, { resourceType, data }) => {
  commit('SET_DATA', { resourceType, data })
}

export const changePerPage = ({ state, commit }, { resourceType, perPage }) => {
  commit('CHANGE_PER_PAGE', { resourceType, perPage })
  // show first on perPage change
  commit('SET_CONFIG', { resourceType, property: 'page', value: 1 })
}

export const setSortField = ({ state, commit }, { resourceType, sortField }) => {
  commit('SET_SORT_FIELD', { resourceType, sortField })
  // show first on perPage change
  commit('SET_CONFIG', { resourceType, property: 'page', value: 1 })
}

export const setSortOrder = ({ state, commit }, { resourceType, sortOrder }) => {
  commit('SET_SORT_ORDER', { resourceType, sortOrder })
  // show first on perPage change
  commit('SET_CONFIG', { resourceType, property: 'page', value: 1 })
}

export const setTotal = ({ state, commit }, { resourceType, total }) => {
  commit('SET_TOTAL', { resourceType, total })
}

export const updateFilter = ({ state, commit }, resourceType, updatedFilter) => {
  commit('UPDATE_FILTER', resourceType, updatedFilter)
}

export const updateListSchemaFields = ({ state, commit }, resourceType, updatedListSchemaFields) => {
  commit('UPDATE_LIST_SCHEMA_FIELDS', resourceType, updatedListSchemaFields)
}

export const reset = ({commit}) => {
  commit('RESET')
}




// WEBPACK FOOTER //
// ./src/store/modules/aboutme/actions.js